// Experience section component

import { ExperienceCard } from './ExperienceCard';
import { PublicExperience } from '../../lib/api';

interface ExperienceSectionProps {
  experiences?: PublicExperience[];
  isLoading?: boolean;
}

export function ExperienceSection({
  experiences,
  isLoading,
}: ExperienceSectionProps) {
  if (isLoading) {
    return (
      <section id="experience" className="section bg-white">
        <div className="container-custom">
          <div className="animate-pulse space-y-6">
            <div className="h-10 w-48 bg-gray-200 rounded" />
            <div className="h-6 w-96 bg-gray-200 rounded" />
            {[1, 2, 3].map((i) => (
              <div key={i} className="card p-6 space-y-4">
                <div className="h-6 w-32 bg-gray-200 rounded" />
                <div className="h-4 w-48 bg-gray-200 rounded" />
                <div className="space-y-2">
                  <div className="h-4 w-full bg-gray-200 rounded" />
                  <div className="h-4 w-full bg-gray-200 rounded" />
                  <div className="h-4 w-3/4 bg-gray-200 rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="experience" className="section bg-white">
      <div className="container-custom">
        {/* Section header */}
        <h2 className="section-title">Experience</h2>
        <p className="section-subtitle">
          Each role includes queryable AI context—the real story behind the
          bullet points.
        </p>

        {/* Experience cards */}
        <div className="max-w-3xl">
          {experiences && experiences.length > 0 ? (
            experiences.map((exp) => (
              <ExperienceCard
                key={exp.id}
                companyName={exp.company_name}
                title={exp.title}
                titleProgression={exp.title_progression}
                startDate={exp.start_date}
                endDate={exp.end_date}
                isCurrent={exp.is_current}
                bulletPoints={exp.bullet_points}
              />
            ))
          ) : (
            <div className="text-center py-12">
              <p className="text-text-secondary">
                Experience data will be loaded from the database once deployed.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
